module.exports = __webpack_public_path__ + "img/setting-treatment-desktop-en.5ffe827c.png";